import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { distinctUntilChanged } from 'rxjs/operators';
import { OmegaCustomerDetails } from '../../models/omega/omega-customer-details';
import { OmegaVehicleDetails } from '../../models/omega/omega-vehicle-details';
import { OmegaService } from '../../services/omega/omega.service';

export class OmegaDetailData {
    constructor(public id, public type) {}
}

@Component({
    selector: 'omega-details-modal',
    templateUrl: './omega-details-update-modal.html',
})

export class OmegaDetailModalComponent {
    context: OmegaDetailData;
    public vehicleId: any;
    public customerNumberId: any;
    public form: UntypedFormGroup;
    public isFormInvalid = true;
    public dataLoaded = false;

    constructor(
        public dialogRef: MatDialogRef<OmegaDetailModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: OmegaDetailData,
        private _omegaService: OmegaService
    ) {
        if (this.data.type == UpdateType.Vehicle) {
            this.vehicleId = this.data.id;
            this._omegaService.getVehicleOmegaDetails(this.vehicleId).subscribe(
                res => {
                    if (res.result) {
                        this.form.patchValue({
                            isProtected: res.result.legendType1 == '1' ? true : false,
                            details: {
                                sponsoringAgency: res.result.legendType2,
                                specialAlert: res.result.legendType3 == '1' ? true : false
                            }
                        });
                    }
                    this.dataLoaded = true;
                    this.isFormInvalid = true;
                }
            );
        } else if (this.data.type == UpdateType.Customer) {
            this.customerNumberId = this.data.id;
            this._omegaService.getCustomerOmegaDetails(this.customerNumberId).subscribe(
                res => {
                    if (res.result) {
                        this.form.patchValue({
                            isProtected: res.result.legendType1 == '1' ? true : false,
                            details: {
                                sponsoringAgency: res.result.legendType2,
                                specialAlert: res.result.legendType3 == '1' ? true : false
                            }
                        });
                    }
                    this.dataLoaded = true;
                    this.isFormInvalid = true;
                }
            );
        }
    }

    ngOnInit() {

        // the long way
        this.form = new UntypedFormGroup({
            isProtected: new UntypedFormControl(false),
            details: new UntypedFormGroup({
                sponsoringAgency: new UntypedFormControl(''),
                specialAlert: new UntypedFormControl(false)
            })
        });

        this.form.valueChanges.pipe(
            distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))).subscribe(values => {
            this.runValidation(values);
        });

    }

    runValidation(data) {
        if (data.isProtected && data.details.sponsoringAgency == '') {
            this.isFormInvalid = true;
        } else if (data.isProtected && data.details.sponsoringAgency != '') {
            this.isFormInvalid = false;
        } else if (!data.isProtected) {
            // Defaulting the values to empty and false when 'isProtected' checkbox is unchecked
            this.form.patchValue({
                isProtected : false,
                details: {
                    sponsoringAgency: '',
                    specialAlert: false
                }
            }, { emitEvent: false });

            this.isFormInvalid = false;
        }
    }

    /**
      * Closes the modal dialog and returns a refund update request model
      */
    public save() {
        var data = this.form.value;
        if (this.vehicleId > 0) {
            var updatedVehicleData = new OmegaVehicleDetails();
            updatedVehicleData.vehicleId = this.vehicleId;
            updatedVehicleData.legendType1 = data.isProtected == true ? '1' : '0';
            if (data.details.sponsoringAgency.length > 10) {
                updatedVehicleData.legendType2 = data.details.sponsoringAgency.substring(0, 10);
            } else {
                updatedVehicleData.legendType2 = data.details.sponsoringAgency;
            }
            updatedVehicleData.legendType3 = data.details.specialAlert == true ? '1' : '0';

            this._omegaService.updateVehicleOmegaDetails(updatedVehicleData).subscribe(res => {
                if (res.result) {
                    this.form.patchValue({
                        isProtected: res.result.legendType1,
                        details: {
                            sponsoringAgency: res.result.legendType2,
                            specialAlert: res.result.legendType3
                        }
                    });
                }
                this.cancel();
            });
        } else if (this.customerNumberId > 0) {
            var updatedCustomerData = new OmegaCustomerDetails();
            updatedCustomerData.customerNumberId = this.customerNumberId;
            updatedCustomerData.legendType1 = data.isProtected == true ? '1' : '0';
            if (data.details.sponsoringAgency.length > 10) {
                updatedCustomerData.legendType2 = data.details.sponsoringAgency.substring(0, 10);
            } else {
                updatedCustomerData.legendType2 = data.details.sponsoringAgency;
            }
            updatedCustomerData.legendType3 = data.details.specialAlert == true ? '1' : '0';

            this._omegaService.updateCustomerOmegaDetails(updatedCustomerData).subscribe(res => {
                if (res.result) {
                    this.form.patchValue({
                        isProtected: res.result.legendType1,
                        details: {
                            sponsoringAgency: res.result.legendType2,
                            specialAlert: res.result.legendType3
                        }
                    });
                }
                this.cancel();
            });
        }
    }
    /**
     * Closes the modal dialog with no return result
     */
    public cancel() {
        this.dialogRef.close();
    }
}

export enum UpdateType {
    Customer = 1,
    Vehicle = 2
}
